import { createApiDescription } from "../../helperFunctions";

export const deliveredReturnInfo = {
    accessLink: createApiDescription(
        "API to fetch access link of taxpayer and spouse.",
        [
            "Returns the taxpayer access link that is received via email upon a delivered return request.",
            "This API will return both taxpayer and spouse if applicable."
        ]
    ),
    e_fileForms: createApiDescription(
        "API to fetch e-file form details for delivered tax returns.",
        [
            "This API will return the names of all forms in the Efile section of a delivered tax return."
        ]
    ),
    archiveReturn: createApiDescription(
        "This API can be used to Archive a return in the Delivered Returns Report page.",
        [
            "Archive Return API will be used to archive the returns, only if the return is present in Delivered reports.",
            "Archive Return API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Archive Return API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    deleteReturn: createApiDescription(
        "This API can be called to delete the return in delivered report.",
        [
            "Delete Return API will be used to delete the returns if only present in Delivered Returns report page or delivered status.",
            "The Deleted return will be moved to the recycle bin page.",
            "Delete Return API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Delete Return API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    deliveredReturns: createApiDescription(
        "This API can be called to get the list of Delivered returns with various filters applied in the request.",
        [
            "Delivered Returns API provide results based on the given filters on the request headers and if no filter values are given, it provides results based on default values mapped with all filters.",
            "The default number of returns in the response will be 10."
        ]
    ),
    recallReturn: createApiDescription(
        "This API can be called to recall the delivered return.",
        [
            "Recall Return API will be used to recall the returns if only present in Delivered Returns report page or delivered status.",
            "The Recalled return will be moved back to In-Process returns page.",
            "Recall Return API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once a request is sent from Recall Return API, the response will be posted to the configured callback endpoint URL.",
            "Recall Return API works only if the given tax return’s signature status is applicable to recall and return will not be recalled for the not applicable statuses.",
        ]
    ),
    resendAccessLink: createApiDescription(
        "This API can be called to Resend the Access Link to the given tax return, based on given taxpayer’s signer guid.",
        [
            "Resend Access Link API is used to resend the access link to the users if only the given return is present in Delivered Returns report page.",
            "Signers guid can be fetched from GET Signer Information API call."
        ]
    ),
    sendReminder: createApiDescription(
        "This API can be used to send the reminder email to the clients.",
        [
            "Send Reminder API will be used to send the reminder to the users if only the given return is present in Delivered Returns report page.",
            "Send Reminder API works only if the given tax return’s signature status is applicable, and reminder will not be sent for the non-applicable statuses.",
        ]
    ),
    signatureStatus: createApiDescription(
        "This API can be called to fetch the Signature status of a tax return by passing the taxreturnID.",
        [
            "Signature status API will be used to get Signature status if only the given return is present in Delivered Returns report page."
        ]
    ),
    signerInformation: createApiDescription(
        "This API can be called to fetch the details of all Signers for a given tax return by passing the taxreturnID.",
        [
            "Signer Information API will be used to get Signer Details if the return is present in Delivered Returns report page."
        ]
    )
}